import { type Address } from './address';

export class StopServiceRequest {
  TurnOffReason?: string;
  MailingAddressDifferent?: boolean;
  ServiceAddressCount?: number;
  MailingAddressUseNewAddressOnAllAccounts?: boolean;
  TotalNumAccounts?: number;
  DetailedInstructions?: string;
  FirstAvailableText?: string;
  AccountNumber?: string;
  PersonId?: string;
  FirstName?: string;
  LastName?: string;
  Email?: string;
  ForwardingAddress?: Address;
  ForwardingAddressType?: string;
  SaId?: string;
  InstructionsForMeterStop?: string;
  StopDate?: string;
}
